import {usePublicProtocol} from '@aboutyou/config';
import {useTranslation} from '@aboutyou/i18n';
import {useInitialLocation} from '@aboutyou/router';
import {
  AdjustTracker,
  useGetUnifiedStoreLink,
} from '../../../Campaigns/hooks/useGetStoreLink';

const paramsMap = new Map<string, string>([
  ['utm_medium', 'referral'],
  ['utm_source', 'onsite_sharing'],
  ['utm_campaign', 'product'],
]);

const getProductLinkUrlParams = (): string => {
  const urlParams = new URLSearchParams();
  for (const [key, value] of paramsMap) {
    urlParams.append(key, value);
  }
  return urlParams.toString();
};

/**
 * When there is no 'shareUrl' present on the product, we use the 'productPath' instead
 * in order to create a product-link which a user can share.
 */
const useProductUrl = (shareUrl: string, productPath: string): string => {
  const {host} = useInitialLocation();
  const protocol = usePublicProtocol();

  let baseUrl = `${protocol}://${host}${productPath}`;

  if (shareUrl.length) {
    baseUrl = shareUrl;
  }

  const productUrl: URL = new URL(baseUrl);
  const urlParams = getProductLinkUrlParams();
  productUrl.search = urlParams;
  return productUrl.href;
};

export const useShareBtnText = (shareUrl: string, productPath: string) => {
  const {t} = useTranslation();

  const unifiedStoreLink = useGetUnifiedStoreLink({
    adjustTracker: AdjustTracker.APP_INSTALL_MWEB,
    options: {
      addOnlyTrackerParam: true,
    },
  });

  const appShareText =
    unifiedStoreLink.length > 0
      ? `${t('Download the app now')}:\n${unifiedStoreLink}`
      : '';

  const productUrl = useProductUrl(shareUrl, productPath);

  const productShareText =
    productUrl.length > 0
      ? `${t('Check out this product at ABOUT YOU')}:\n${productUrl}`
      : '';

  return `${productShareText}\n\n${appShareText}`;
};
